import {IBreadCrumb} from "@/@types/health/healthBreadcrumb";
import {
    FAMILY_TYPE_COUPLE,
    FAMILY_TYPE_COUPLE_WITH_CHILDREN,
    FAMILY_TYPE_SINGLE_WITH_CHILDREN
} from "@/app/enums/Health/FamilyTypeEnum";
import {
    STEP_EFFECTIVE_DATE,
    STEP_FAMILY_TYPE, STEP_INFOS,
    STEP_NEEDS,
    STEP_PARTNER_BIRTHDAY_DATE
} from "@/app/enums/Health/FormStepsEnum";

const toCamel = (s: any) => {
    // eslint-disable-next-line
    return s.replace(/([-_][a-z])/ig, ($1: any) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '')
    })
}
const isArray = (arr: any) => Array.isArray(arr)
export const isObject = (obj: any) => obj === Object(obj) && !isArray(obj) && typeof obj !== 'function' && obj !== null

export const keysToCamel = (obj: any): any => {
    if (isObject(obj)) {
        const n = {}

        Object.keys(obj)
            .forEach((key) => {
                // @ts-ignore
                n[toCamel(key)] = keysToCamel(obj[key])
            })

        return n
    }
    if (isArray(obj)) {
        return obj.map((i: any) => keysToCamel(i))
    }

    return obj
}

export const getBreadCrumbsList = (familyType: number | null): IBreadCrumb[] => {
    if (familyType === FAMILY_TYPE_COUPLE) {
        return [
            {
                step: STEP_FAMILY_TYPE,
                visible_step: 1,
                label: "Votre profil",
            },
            {
                step: STEP_PARTNER_BIRTHDAY_DATE,
                visible_step: 2,
                label: "Votre conjoint(e)",
            },
            {
                step: STEP_EFFECTIVE_DATE,
                visible_step: 3,
                label: "Votre contrat",
            },
            {
                step: STEP_NEEDS,
                visible_step: 4,
                label: "Vos besoins",
            },
            {
                step: STEP_INFOS,
                visible_step: 5,
                label: "Vos coordonnées",
            },
        ];
    }

    if (
        familyType === FAMILY_TYPE_SINGLE_WITH_CHILDREN ||
        familyType === FAMILY_TYPE_COUPLE_WITH_CHILDREN
    ) {
        return [
            {
                step: STEP_FAMILY_TYPE,
                visible_step: 1,
                label: "Votre profil",
            },
            {
                step: STEP_PARTNER_BIRTHDAY_DATE,
                visible_step: 2,
                label: "Votre famille",
            },
            {
                step: STEP_EFFECTIVE_DATE,
                visible_step: 3,
                label: "Votre contrat",
            },
            {
                step: STEP_NEEDS,
                visible_step: 4,
                label: "Vos besoins",
            },
            {
                step: STEP_INFOS,
                visible_step: 5,
                label: "Vos coordonnées",
            },
        ];
    }

    return [
        {
            step: STEP_FAMILY_TYPE,
            visible_step: 1,
            label: "Votre profil",
        },
        {
            step: STEP_EFFECTIVE_DATE,
            visible_step: 2,
            label: "Votre contrat",
        },
        {
            step: STEP_NEEDS,
            visible_step: 3,
            label: "Vos besoins",
        },
        {
            step: STEP_INFOS,
            visible_step: 4,
            label: "Vos coordonnées",
        },
    ];
};
